import React from 'react';
import { Credential } from '@nexla/@types';
import { CredentialWidget } from './CredentialWidget';
import { useCredentialWidgetData } from './useCredentialWidgetData';

type CredentialWidgetCredential = Pick<Credential, 'id' | 'name' | 'owner' | 'validStatus'>;

type CredentialWidgetFromPropsProps = {
  credential?: CredentialWidgetCredential | null;
};

/**
 * Adapt a credential entity for the shared credential widget.
 * @example <CredentialWidgetFromProps credential={credential} />
 */
export function CredentialWidgetFromProps({
  credential,
}: CredentialWidgetFromPropsProps): JSX.Element | null {
  const widgetData = useCredentialWidgetData(credential);

  if (!widgetData) return null;
  return <CredentialWidget {...widgetData} />;
}
